module.exports = __webpack_public_path__ + "img/icon_quanbao@2x.5be43453.png";